import { WMSTileLayer } from 'react-leaflet';
import { LatLngTuple } from 'leaflet';

export const getCenterAndZoom = (
    caseStudyCode: string | undefined,
    locationCode?: string | undefined // Add this optional parameter
): { center: LatLngTuple, zoom: number } => {
    switch (caseStudyCode?.toLowerCase()) {
        case 'cyprus':
            return { center: [34.756757, 33.316817], zoom: 12 }; // Limassol, Cyprus

        case 'greece':
            // New logic to handle specific Greek locations
            switch (locationCode?.toLowerCase()) {
                case 'evia':
                    return { center: [38.0810, 24.5540], zoom: 11 };
                case 'thrace':
                    return { center: [41.0640, 25.9340], zoom: 11.5 };
                default:
                    return { center: [37.9838, 23.7275], zoom: 6.3 }; // Default for Greece
            }

        case 'barcelona':
            return { center: [41.3851, 2.1734], zoom: 10 }; // Barcelona, Spain

        case 'pnr_narbonnaise':
            return { center: [43.024819, 2.970399], zoom: 10 }; // pnr_narbonnaise, France

        case 'cbnmed':
            return { center: [43.567800, 3.438540], zoom: 6.3 }; // pnr_narbonnaise, France

        default:
            return { center: [34.7071, 33.0226], zoom: 3 }; // Default position
    }
};


export const generateLayer = (code: string, url: string, layers: string, zIndex: number) => (
    <WMSTileLayer
        key={`${code}`}
        url={`${url}`}
        layers={`${layers}`}
        format="image/png"
        transparent={true}
        version="1.1.1"
        attribution="Your attribution text"
        zIndex={zIndex}
    />
);